var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "#FAF7F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0044 9.68168V7.49252C24.0044 7.30278 23.7864 7.19799 23.6391 7.31411L10.8723 17.2857C10.7638 17.37 10.6761 17.4781 10.6157 17.6015C10.5553 17.7249 10.5239 17.8605 10.5239 17.9979C10.5239 18.1354 10.5553 18.271 10.6157 18.3944C10.6761 18.5178 10.7638 18.6258 10.8723 18.7102L23.6391 28.6818C23.7892 28.7979 24.0044 28.6931 24.0044 28.5034V26.3142C24.0044 26.1754 23.9393 26.0423 23.8317 25.9574L13.6364 17.9994L23.8317 10.0385C23.9393 9.95356 24.0044 9.82045 24.0044 9.68168Z",
    fill: "#508BEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#D9D1C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.c788b997ef390559e36fb54702962110.svg";
export { ForwardRef as ReactComponent };